var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2930_788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.69604 7.172L4.88004 9.692",
    stroke: "#282827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66394 17.764L4.83994 15.26",
    stroke: "#282827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3361 18.74L19.5681 21.284",
    stroke: "#282827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.416 10.5002H12.4V14.5002H19.328C18.9016 16.0714 17.9823 17.4644 16.7054 18.4744C15.4285 19.4844 13.8613 20.0581 12.2341 20.1113C10.6069 20.1645 9.00555 19.6942 7.66543 18.7697C6.32532 17.8452 5.31712 16.5152 4.78901 14.9752C4.26091 13.4351 4.24077 11.7662 4.73154 10.2138C5.22232 8.66149 6.1981 7.30752 7.5155 6.35094C8.83291 5.39435 10.4225 4.8857 12.0505 4.89957C13.6785 4.91344 15.2591 5.44919 16.56 6.42808L19.416 3.58004C17.4542 1.94432 15.0077 1.00134 12.4555 0.897224C9.90341 0.793108 7.3882 1.53378 5.29968 3.00426C3.21117 4.47473 1.66598 6.59301 0.903566 9.03082C0.141151 11.4686 0.20408 14.0898 1.08262 16.4882C1.96116 18.8867 3.60623 20.9283 5.76292 22.2968C7.9196 23.6654 10.4675 24.2845 13.0117 24.058C15.5559 23.8315 17.9543 22.7721 19.8354 21.0441C21.7164 19.3161 22.9749 17.016 23.416 14.5002C23.5386 13.8405 23.6001 13.1711 23.6 12.5002C23.5994 11.8293 23.5378 11.1599 23.416 10.5002V10.5002Z",
    stroke: "#282827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2930_788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/Icon-Google.5db25200d2cbd11a9ae5e552c382aff3.svg";
export { ForwardRef as ReactComponent };